import * as React from "react"

const SoundWaveSymbol = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="9" height="10" {...props}>
    <path d="M0 8V2h1v6H0Zm2 2V0h1v10H2Zm2-3V3h1v4H4Zm2 3V0h1v10H6Zm2-2V2h1v6H8Z" />
  </svg>
)

export default SoundWaveSymbol
